"use client";

import IconTextCard from "@/components/pages/bus/cards/IconTextCard.jsx";
import ImageCardWrapper from "@/components/pages/bus/cards/ImageCardWrapper.jsx";
import DynamicStats from "@/components/DynamicStats.js";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import BusTripSchema from "@/components/pages/bus/customSchema/BusTripSchema";

import { 
  CampaignCard, 
  IconText,
} from "@/components/featured/common";

import { 
  BlogCard,
  RouteDealCard,
} from "@/components/featured/bus";

export const componentRegistry = {
  CampaignCard,
  BlogCard,
  RouteDealCard,
  IconTextCard,
  IconText,
  ImageCardWrapper,
  DynamicStats,
  OpportunitiesCardWrapper,
  BusTripSchema,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  BlogCard: "post",
  RouteDealCard: "item",
  IconTextCard: "item",
  ImageCardWrapper: "item",
  DynamicStats: "stats",
  BusTripSchema: "data",
};
